import { getUserId, orgSearch } from '../helpers';
import { api } from './api';
import { searchGetCourseMeta } from './index';

export async function getUserCoursesAPI(username, callback) {
  api.ibldmcourses.getUserCourses({ username }, async function (data) {
    const courses = data?.results ? data.results : [];
    if (courses.length === 0) {
      callback([]);
      return;
    }

    const coursePromises = courses.map((course) => {
      return new Promise((resolve) => {
        const id = course?.course_id;
        searchGetCourseMeta(id, (metaData) => {
          if (metaData && !metaData.message && metaData.results.length > 0) {
            resolve(metaData.results[0]);
          } else {
            resolve(null);
          }
        });
      });
    });

    const allCourseData = (await Promise.all(coursePromises)).filter(
      (courseData) => courseData !== null
    );

    callback(allCourseData);
  });
}
